/**
 * Created by glenn on 7/25/2017.
 */


import React = require("react");
import {connect} from 'react-redux'
import {RadioConnected} from 'webmapsjs/dist/reactComponents/Radio';
import {Slider} from 'webmapsjs/dist/reactComponents/Slider';
import {iState, setSlider, store} from './store';
import {ACTION_SET_VEHICLE} from './actions';
import {iRoad, iRoute, iSpeed, iSpeedVal} from "webmapsjs/dist/api/_npmrdsInterfaces";
import * as colors from 'webmapsjs/dist/util/colors';
import {keyValPairs} from "webmapsjs/dist/util/objectHelpers";


class _DateUl extends React.Component<{ dates: string[] }, null> {

    render() {
        let dateList = [];

        for (let p of this.props.dates) {
            dateList.push(<div key={p}><span>{p}</span></div>)
        }

        return <div className="dates-list">
            {dateList}
        </div>;
    }
}

function mapDateUlState(s: iState) {
    return {
        dates: s.data.speed.dates
    }
}

function speedToText(t: string, s: iSpeedVal, free: number): string {
    let parts = s.date.split(/\s/);

    let date = parts[0];

    let amPm = 'AM';

    let timeParts = parts[1].split(':');

    let hr = parseInt(timeParts[0]);

    if (hr >= 12) {
        amPm = 'PM';
        hr -= 12;
    }

    if (hr == 0) {
        hr = 12;
    }

    timeParts[0] = hr.toFixed();


    let retHtml = '<table>';
    retHtml += `<tr><td>TMC</td><td>${t}</td></tr>`;
    retHtml += `<tr><td>Datetime</td><td>${date}<br/>${timeParts.join(':')} ${amPm}</td></tr>`;
    retHtml += `<tr><td>All</td><td>${s.all}</td></tr>`;
    retHtml += `<tr><td>Passenger</td><td>${s.pas}</td></tr>`;
    retHtml += `<tr><td>Freight</td><td>${s.frgt}</td></tr>`;
    retHtml += `<tr><td>Free Flow</td><td>${free}</td></tr>`;

    retHtml += '</table>';

    return retHtml;
}

class _HeatmapCanvas extends React.Component<{ slider: number, bins: number, speedProp: string, speed: iSpeed, roads: iRoad[] },
    {}> {
    private canvas: HTMLCanvasElement;
    private canvasContext: CanvasRenderingContext2D;
    private canvasContainerDiv: HTMLDivElement;
    private data: iRoute;
    private vehicle: string;
    private tmcStartEnd: { [s: string]: number[] } = {};
    private tooltipSpan: HTMLSpanElement;
    private moveInfo: (e: any) => any;
    private mouseEnter: () => any;
    private mouseLeave: () => any;


    constructor(props, context) {
        super(props, context);

        this.data = undefined;
        this.vehicle = undefined;

        this.moveInfo = (e) => {
            this._moveInfo(e);
        };

        this.mouseEnter = () => {
            this._mouseEnter();
        };

        this.mouseLeave = () => {
            this._mouseLeave();
        };
    }

    _mouseEnter() {
        this.tooltipSpan.style.display = 'inherit';
    }

    _mouseLeave() {
        this.tooltipSpan.style.display = 'none';
    }

    _moveInfo(evt) {
        // coordinates relative the canvas
        let offsetX = evt.offsetX;
        let offsetY = evt.offsetY;

        // coordinates relative the window
        let clientX = evt.clientX;
        let clientY = evt.clientY;

        let state: iState = store.getState() as iState;

        let tmc: string = null;

        for (let t of state.data.roads[0].tmcs) {
            if (offsetX >= this.tmcStartEnd[t][0] && offsetX < this.tmcStartEnd[t][1]) {
                tmc = t;
                break;
            }
        }

        let free = state.data.speed.free[tmc];

        let d = state.data.speed.values[tmc][Math.floor(offsetY / 2)];

        this.tooltipSpan.innerHTML = speedToText(tmc, d, free);

        this.tooltipSpan.style.left = (clientX - 175).toFixed() + 'px';
        this.tooltipSpan.style.top = (clientY - 155).toFixed() + 'px';
    }

    clearCanvas() {
        this.canvasContext = this.canvas.getContext('2d');
        this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.canvas.removeEventListener('mousemove', this.moveInfo);
        this.mouseLeave();
        this.canvas.removeEventListener('mouseleave', this.mouseLeave);
        this.canvas.removeEventListener('mouseenter', this.mouseEnter);

    }

    draw(force = false) {


        setTimeout(() => {




            let state: iState = store.getState() as iState;

            if (this.data == state.data && this.vehicle == state.vehicle && !force) {
                return;
            }

            this.clearCanvas();

            this.data = state.data;
            this.vehicle = state.vehicle;

            if (this.data.roads.length == 0) {
                return;
            }

            let tmcs = this.data.roads[0].tmcs;
            let total = this.data.totalDistance;

            console.log(tmcs.length);

            this.tmcStartEnd = {};

            let runningLength = 0;

            for (let i = 0; i < tmcs.length; i++) {

                let tmcLen = this.data.lengths[tmcs[i]];
                let start = runningLength;
                let end = runningLength + tmcLen;
                start /= total;
                end /= total;
                start *= this.canvas.width;
                end *= this.canvas.width;
                start = Math.floor(start);
                end = Math.ceil(end);
                this.tmcStartEnd[tmcs[i]] = [start, end];
                runningLength += tmcLen;
            }

            let speedLen = 0;

            for (let t of tmcs){
                if (this.data.speed.values[t] && this.data.speed.values[t].length > speedLen){
                    speedLen = this.data.speed.values[t].length;
                }
            }

            for (let t of tmcs) {
                let speeds = this.data.speed.values[t];
                let startX = this.tmcStartEnd[t][0];
                let width = this.tmcStartEnd[t][1] - this.tmcStartEnd[t][0];
                let freeSpeed = this.data.speed.free[t];

                let colorGradientStdDev = colors.makeBlueGreenRedGradientZScore(freeSpeed, this.data.speed.std[t], true);

                for (let i = 0; i < speedLen; i++) {

                    let sp = undefined;

                    if (speeds && speeds[i][this.props.speedProp]){
                        sp = speeds[i][this.props.speedProp];
                    }
                    if (!sp) {
                        this.canvasContext.fillStyle = 'gray';
                    } else if (sp >= freeSpeed) {
                        this.canvasContext.fillStyle = 'blue';
                    } else {
                        this.canvasContext.fillStyle = colorGradientStdDev(sp);
                    }


                    this.canvasContext.fillRect(startX, i * 2, width, 2);
                }
            }

            this.canvas.addEventListener('mousemove', this.moveInfo);
            this.canvas.addEventListener('mouseleave', this.mouseLeave);
            this.canvas.addEventListener('mouseenter', this.mouseEnter);

        }, 30);
    }

    componentDidMount() {
        this.canvasContainerDiv = (document.getElementById('heatmap-canvas-container') as HTMLDivElement);
        this.canvas = (document.getElementById('heatmap-canvas') as HTMLCanvasElement);
        this.canvasContext = this.canvas.getContext('2d');

        this.tooltipSpan = document.getElementById('canvas-tooltip-div') as HTMLSpanElement;
        this.canvas.width = this.canvasContainerDiv.clientWidth - 20;

        setTimeout(() => {
            this.draw(true);
        }, 100);

        store.subscribe(() => {
            this.draw()
        });

        document.getElementsByTagName('body')[0].addEventListener('resize', () => {
            console.log('resize');
        })
    }

    componentDidUpdate() {
        this.draw();
        console.log('here');
    }

    render() {
        let style = {width: `${this.props.bins * 2}px`};

        if (this.canvas) {
            style['left'] = `${(this.canvas.width * this.props.slider / 100).toFixed()}px`;
        }

        return <div id="heatmap-canvas-container">
            <hr style={style}/>
            <div id="canvas-tooltip-div"/>
            <canvas id="heatmap-canvas" height={this.props.bins * 2}/>
        </div>
    }
}

const HeatmapCanvas = connect(
    (state: iState) => {
        let veh: string = 'all';

        if (state.vehicle == 'Passenger') {
            veh = 'pas';
        } else if (state.vehicle == 'Freight') {
            veh = 'frgt';
        }

        return {
            bins: state.data.speed.count,
            slider: state.slider,
            speedProp: veh,
            speed: state.data.speed,
            roads: state.data.roads
        }
    }
)(_HeatmapCanvas);

const DateUl = connect(mapDateUlState)(_DateUl);

const SliderConnected = connect(
    (state: iState) => {
        return {
            value: state.slider,
            change: setSlider,
        }
    })(Slider);


let vehicleItems = ['All', 'Passenger', 'Freight'];

const VehicleType = connect(
    (state: iState) => {

        let sel = -1;

        for (let i = 0; i < vehicleItems.length; i++) {
            if (state.vehicle == vehicleItems[i]) {
                sel = i;
                break;
            }
        }

        return {
            items: vehicleItems,
            selectedIndex: sel,
            title: "Vehicle Type",
            inline: true,
        }
    },
    (dispatch) => {
        return {
            callback: (d) => {
                dispatch({type: ACTION_SET_VEHICLE, vehicle: vehicleItems[d]})
            }
        }
    }
)(RadioConnected);

export class HeatMap extends React.Component<{}, null> {

    componentDidMount() {
    }

    render() {
        return <div className="right">
            <div className="heat-map-controls">
                <VehicleType/>
                <div className="heat-map-flex">
                    <div/>
                    <SliderConnected/>
                </div>
            </div>
            <div className="heat-map-flex heat-map-container">
                <DateUl/>
                <HeatmapCanvas/>
            </div>
        </div>
    }
}